import type { Auth0ContextInterface, User } from "@auth0/auth0-react";
import { createRootRouteWithContext, Outlet, redirect } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";

import { WelcomeStep } from "core/models/welcome";
import { query } from "features/start/data";
import { useStoreWelcome } from "areas/welcome/store";


export type RouterContext = {
	queryClient: QueryClient;
	auth0?: Auth0ContextInterface<User>
};

export const Route = createRootRouteWithContext<RouterContext>()({
	component: () => <Outlet />,
	beforeLoad: async ({ context }) => {
		const { queryClient, auth0 } = context;
		await queryClient.ensureQueryData(query.auth0(auth0!));
	},
	loader: async ({ context, location }) => {
		const { queryClient, auth0 } = context;

		if (auth0?.isAuthenticated) {
			const status = await queryClient.ensureQueryData(query.status);

			const onboarded = status.partners.some(p => p.step === WelcomeStep.Done);
			if (!onboarded) {
				const partner = status.partners.find(p => p.step) || status.partners[0];
				if (partner && !location.pathname.startsWith("/welcome")) {
					const welcome = useStoreWelcome.getState();
					welcome.setStep(partner.step);

					throw redirect({
						to: "/welcome/$partnerId",
						params: { partnerId: partner.id.toString() }
					});
				}
			}
		}
	}
});